import { type HttpErrorProps } from '@leaflink/stash/HttpError.vue';

/**
 * These error codes are used to display error pages
 */
export const supportedErrorPageCodes: HttpErrorProps['errorCode'][] = [401, 403, 404, 405, 500, 502, 503, 504] as const;

export type SupportedErrorPageCodes = (typeof supportedErrorPageCodes)[number];
